import { Component, OnInit, Input } from '@angular/core';
import { AccountModel } from 'app/model/auth.account.model';
import { AuthService } from 'app/services/auth/auth.service';
import { RedirectService } from 'app/services/page/redirect.service';
import { Router, NavigationEnd } from '@angular/router';

@Component({
    selector: 'head-menu',
    templateUrl: './head-menu.component.html',
    styleUrls: ['./head-menu.component.scss']
})
export class HeadMenuComponent implements OnInit {

    hidden: boolean = false;

    loaded: boolean;
    accountInfo: AccountModel;

    constructor(private authService: AuthService, private redirectService: RedirectService, private router: Router) {
        this.loaded = false;

        // 相談者確認の時、ログインボタンは非表示にする
        router.events
            .filter(event => event instanceof NavigationEnd)
            .subscribe(event => this.onRouterUrlChange(event['url']));
     }

    async ngOnInit() {

        this.onRouterUrlChange(this.router.url);

        try {
            this.accountInfo = await this.authService.getAccount();
        } catch(err) {
            console.log(err.message);
        } finally {
            this.loaded = true;
        }
    }


    googleLogin() {
        this.redirectService.setRedirectUrl(this.router.url);
        window.location.href = '/v1/router/auth/google';
    }


    private onRouterUrlChange(routerUrl: string) {

        if (routerUrl && routerUrl.indexOf('/display') == 0) {
            this.hidden = true;
        } else {
            this.hidden = false;
        }
    }
}



// WEBPACK FOOTER //
// E:/02_workspace/TenneT/git/tennet_suggestion_box/client/src/app/components/head-menu/head-menu.component.ts